import { createFileRoute } from "@tanstack/react-router";
import { SilverPage, silverRatesQO } from "@/components/SilverPage";
import { buildAliasHead } from "@/lib/alias-routes";

const TITLE = "Today's Live Chandi Ka Rate in Kanpur — 1 Tola & 10 Gram Price";
const DESC = "Live silver / chandi rate in Kanpur today — per tola, per 10 gram, per gram & per kg. Hourly auto-update from international XAG spot + USD/INR FX.";

export const Route = createFileRoute("/silver-rate-kanpur")({
  head: () => buildAliasHead({ title: TITLE, description: DESC, path: "/silver-rate-kanpur" }),
  loader: ({ context }) => context.queryClient.ensureQueryData(silverRatesQO),
  component: () => (
    <SilverPage
      country="india"
      cityName="Kanpur"
      title="Today's Live Chandi (Silver) Rate in Kanpur"
      intro="Live silver rate in Kanpur — recalculated every 10 minutes from international XAG spot price and today's USD/INR rate. Per tola, per 10 gram, per gram and per kilogram."
    />
  ),
});
